import React from "react";
import { Link } from "react-router-dom";
import { Basket } from "./Basket";

type Props = {
	club: any;
	slug: string;
	/** Re-read the count when the basket has just changed. */
	basketVersion?: number;
};

/**
 * The club's identity and the way back to the basket.
 *
 * The badge and name come from the API rather than the bundle, because this
 * page is one URL per club and a supporter arriving from their club's website
 * should not see Pitchbase branding first.
 */
export function ShopHeader({ club, slug, basketVersion }: Props) {
	// basketVersion is unused directly — it exists so a parent that has just
	// changed the basket can force this to re-read localStorage, which React
	// has no way of observing on its own.
	void basketVersion;
	const count = Basket.count(slug);

	return (
		<header className="shop-header">
			{club?.badgeUrl && <img alt="" src={club.badgeUrl} />}
			<h1>{club?.name || "Tickets"}</h1>
			{count > 0
				? <Link className="shop-basket-link" to={`/club/${slug}/basket`}>Basket · {count}</Link>
				: <Link to={`/club/${slug}`}>Tickets</Link>}
		</header>
	);
}
